<template>
  <div v-if="reloadComponentDiv">
    <devAddLineInputs v-if="showLineInputs" :typeLine="lineInputsEdit" :objItem="objItem" @actionList="actionList" @close="closeLine" />

    <div v-if="btnAdd" class="d-flex justify-end mt-2 mr-2">
      <v-btn @click="handleShowLineAddAttributes" small class="px-2 white--text" color="grey darken-3">
        Adicionar
        <v-icon class="ml-2 white--text" small>add</v-icon>
      </v-btn>
    </div>

    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left px-2" width="45%">Atributo</th>
            <th class="text-left px-2" width="45%">Valor</th>
            <th class="text-right px-2" width="10%">
              <div v-if="!btnAdd" class="d-flex">
                <v-icon class="mr-2" @click="handleShowLineAddAttributes" small>add</v-icon>
                <v-icon v-if="btnDelete" @click="deleteObjFather" small color="red">delete</v-icon>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in attrList" :key="index">
            <template v-if="checkArray(item)">
              <td class="px-2" width="45%">
                <span class="font-weight-medium grey--text text--darken-3">{{ Object.keys(item)[0] }}</span>
              </td>

              <td class="px-2 font-weight-light primary--text" width="45%">{{ Object.values(item)[0] }}</td>

              <td class="text-right mr-0 px-2" width="10%">
                <v-menu left>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="mr-0" size="18">mdi-dots-vertical</v-icon>
                  </template>

                  <v-list class="py-0" dense hover>
                    <v-list-item class="px-0 py-0">
                      <v-list-item-title>
                        <v-btn @click="handleShowLineEditAttributes(item, index)" text width="100%">
                          <v-icon color="grey darken-3" class="mr-2" small>edit</v-icon>Editar
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item class="px-0 py-0">
                      <v-list-item-title>
                        <v-btn @click="deleteObj(item, index)" text width="100%">
                          <v-icon color="red" class="mr-2" small>delete</v-icon>Excluir
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>

            <td v-if="checkObject(item, 'Object')" colspan="3" class="px-0" width="100%">
              <v-expansion-panels hover focusable>
                <v-expansion-panel class="v-expansion-panel--expandable-table">
                  <v-expansion-panel-header>
                    <span class="my-0 pl-2 font-weight-medium primary--text">{{ Object.keys(item)[0] }}</span>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <devAttrCrudVuetify
                      :value="Object.values(item)[0]"
                      :btnAdd="false"
                      :listView="attrList"
                      :indexListView="index"
                      :valueDad="value"
                      :nameKey="Object.keys(item)[0]"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div v-if="listComboBox.length !== 0" class="border-top-default">
      <div class="col-12" v-for="(itemComboBox, index) in listComboBox" :key="index">
        <v-combobox
          v-model="value[itemComboBox.name]"
          :items="itemComboBox.result"
          :search-input.sync="itemComboBox.searchItems"
          :label="itemComboBox.name"
          hide-selected
          multiple
          persistent-hint
          small-chips
          deletable-chips
          clearable
          dense
          append-icon="zmdi zmdi-chevron-down"
          class="mt-4 mb-3"
          hide-details
        >
          <template v-slot:no-data>
            <v-list-item dense>
              <v-list-item-content>
                <v-list-item-title>
                  No results matching "
                  <strong>{{ itemComboBox.searchItems }}</strong
                  >". Press <kbd>enter</kbd> to create a new one
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  props: {
    value: { type: [Object, Array], default: () => ({} || []) },
    btnAdd: { type: Boolean, default: true },
    valueDad: { type: [Object, Array], default: () => ({} || []) },
    nameKey: { type: String, default: '' },
    listView: { type: Array, default: () => [] },
    indexListView: { type: Number, default: 0 },
    btnDelete: { type: Boolean, default: true },
    model: { type: Object, default: () => ({}) },
    schema: { type: Object, default: () => ({}) }
  },

  data: () => ({
    attrList: [],
    setLineAddType: 'addAttrObj',
    copyModels: {},
    reloadComponentDiv: true,
    showLineInputs: false,
    lineInputsEdit: false,
    objItem: { key: '', value: '' },
    listComboBox: []
  }),

  components: {
    devAddLineInputs: () => import('@/components/dev/dev-add-line-inputs'),
    devAttrCrudVuetify: () => import('@/components/dev/dev-attr-crud-vuetify')
  },

  mounted() {
    this.getValueList(this.schema.modelFather ? this.model : this.value);
  },

  methods: {
    getValueList(list) {
      for (let [key, value] of Object.entries(list)) {
        if (value.__proto__.constructor.name === 'Array' && typeof value[0] === 'string') {
          this.listComboBox.push({ name: key, result: value, searchItems: '' });
        } else {
          this.attrList.push({ [key]: value });
        }
      }
    },

    checkArray(item) {
      if (Object.values(item)[0].__proto__) {
        if (Object.values(item)[0].__proto__.constructor.name != 'Array' && Object.values(item)[0].__proto__.constructor.name != 'Object') {
          return true;
        }
      }

      return false;
    },

    checkObject(item, type) {
      if (Object.values(item)[0].__proto__ && Object.values(item)[0].__proto__.constructor.name === type) {
        return true;
      }

      return false;
    },

    closeLine() {
      this.showLineInputs = false;
    },

    reloadComponent() {
      this.reloadComponentDiv = false;

      this.$nextTick(() => (this.reloadComponentDiv = true));
    },

    actionList(result) {
      if (result.type == 'edit') {
        this.editAttrObj(result.key, result.value);
      } else {
        this.addAttrObj(result.key, result.value);
      }
    },

    handleShowLineAddAttributes() {
      this.lineInputsEdit = false;
      this.showLineInputs = true;
    },

    handleShowLineEditAttributes(itemObj, index) {
      let itemKey = Object.keys(itemObj)[0];
      let itemValue = Object.values(itemObj)[0];

      this.objItem.key = itemKey;
      this.objItem.value = itemValue;

      this.lineInputsEdit = true;
      this.showLineInputs = true;

      this.copyModels.key = itemKey;
      this.copyModels.value = itemValue;
      this.copyModels.index = index;
    },

    addAttrObj(key, value) {
      this.attrList.push({ [key]: value });
      this.schema.modelFather ? (this.model[key] = value) : (this.value[key] = value);

      this.showLineInputs = false;

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    editAttrObj(key, value) {
      this.attrList[this.copyModels.index] = { [key]: value };

      if (this.copyModels.key !== key) this.schema.modelFather ? delete this.model[this.copyModels.key] : delete this.value[this.copyModels.key];

      this.schema.modelFather ? (this.model[key] = value) : (this.value[key] = value);

      this.showLineInputs = false;

      this.reloadComponent();

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    deleteObj(item, index) {
      this.attrList.splice(index, 1);

      this.schema.modelFather ? delete this.model[Object.keys(item)[0]] : delete this.value[Object.keys(item)[0]];

      this.reloadComponent();

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    deleteObjFather() {
      this.listView.splice(this.indexListView, 1);

      delete this.valueDad[this.nameKey];
    }
  }
};
</script>
